import styled from "styled-components"
import { pageContainerStyles } from "ui/theme"

export const ContainerStyled = styled.div`
  ${pageContainerStyles}
  height: 100%;
`
